import React from 'react';
import Cover from './cover.js';
import Image from './image.js';
import {Heart, EmptyHeart} from './icons.js';
import {reisy, use} from 'reisy';
import {hasLocalStorage} from '../environment'
import {injectIntl, defineMessages} from 'react-intl';
import {post, del} from '../xhr';
import PropTypes from 'prop-types';

const messages = defineMessages({
	likesLabel: {
		id: "like.label",
		defaultMessage: `{likeCount, number} {likeCount, plural,
			one {Likes this}
			other {Like this}
		}`,
	},
	noLikesLabel: {
		id: "like.noLikeLabel",
		defaultMessage: "Like this",
	},
});

export const styles = reisy`
@namespace Like;

wrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	cursor: pointer;
	font-family: $Fonts.aside;
	font-weight: normal;
	margin-top: .5em;

	svg {
		width: 20px;
		height: 20px;
		margin-right: .5em;
	}
}

noText {
	margin: 0;

	svg {
		margin: 0;
	}
}

liked {

}
`;

const settings = reisy.namespace("Settings");

const LIKE_KEY = 'pagestriplikes';

const likes = IS_BROWSER && hasLocalStorage ? (localStorage.getItem(LIKE_KEY) || '').split(':').filter(Boolean) : [];

class Like extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			checked: this._isChecked(props),
			likeCount: props.publishable.likes,
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			checked: this._isChecked(nextProps),
			likeCount: nextProps.publishable.likes,
		});
	}

	_isChecked(props) {
		const {publishable: {uid}} = props;
		return likes.some(l => l === uid);
	}

	_like() {
		if (hasLocalStorage) {
			const {publishable} = this.props;
			let {likeCount, checked} = this.state;
			
			if (!checked) {
				post(this.context.player.api._API_BASE + 'api/v1/likes/', {
					id: publishable.uid,
					type: 'publishable'
				}, {withCredentials: true});
				likes.push(publishable.uid);
				likeCount += 1;
			} else {
				del(this.context.player.api._API_BASE + 'api/v1/likes/', {
					id: publishable.uid,
					type: 'publishable'
				}, {withCredentials: true});
				likeCount--;
				likes.splice(likes.indexOf(publishable.uid), 1);
			}

			localStorage.setItem(LIKE_KEY, likes.join(':'));
			
			checked = !checked;

			publishable.likes = likeCount;
			this.setState({
				checked,
				likeCount,
			});
		}
	}

	render() {
		const {checked, likeCount} = this.state;
		const {intl: {formatMessage}, noText, publishable: {uid}, style} = this.props;

		if(!uid) return null;

		return (
			<div {...use(styles.wrapper, noText ? styles.noText : null, checked ? styles.liked : null, style)} onClick={() => this._like()}>
				{checked ? <Heart /> : <EmptyHeart />}
				{!noText && (likeCount > 0 ? formatMessage(messages.likesLabel, {likeCount}) : formatMessage(messages.noLikesLabel))}
			</div>
		);
	}
}

Like.contextTypes = {
	player: PropTypes.object
}

export default injectIntl(Like);



// WEBPACK FOOTER //
// ./lib/components/like.js